import React, { useMemo } from 'react'
import styled from 'styled-components'
import Spinner from 'react-loader-spinner'
import Modal, { Title } from 'components/Dialogs/Modal'
import Hr from 'components/HorizontalRuler'
import Button from 'components/Button'
import { RFP_STATE } from '../../../constants'
import { IconCheckCircle as BaseIconCheckCircle } from '@loadsmart/icons'

const Label = styled.div`
  font-weight: 800;
`
const P = styled.p`
  margin-top: 25px;
`
const Ul = styled.ul`
  margin-top: 15px;
  text-align: left;
  font-size: 14px;
  line-height: 141.8%;

  li {
    margin-bottom: 15px;
  }
`
const CancelButton = styled(Button)`
  margin-top: 15px;
`
const ConfirmButton = styled(Button)`
  margin-top: 25px;
`
const IconCheckCircle = styled(BaseIconCheckCircle)`
  color: ${({ theme }) => theme.colors.main};
`

export default function AwardDialog({
  rfp,
  isOpen,
  onConfirm,
  onClose,
}: {
  rfp: RequestForProposalDetail
  isOpen: boolean
  onConfirm?: () => void
  onClose?: () => void
}) {
  const carriers = useMemo(() => {
    const data: Record<number, Carrier> = {}
    Object.values(rfp.lanes).forEach((lane) => {
      Object.values(lane.awarded_proposals || {}).forEach((proposal) => {
        if (proposal?.carrier) {
          data[proposal.carrier.id] = proposal.carrier
        }
      })
    })
    return data
  }, [rfp])

  return (
    <Modal isOpen={isOpen} contentLabel="Confirmation">
      {rfp.state === RFP_STATE.FINALIZED ? (
        <div>
          <Title>RFP Finished</Title>
          <Hr />
          <IconCheckCircle width={51} height={51} />
          <p>
            The RFP {rfp.name} is finished and all award emails are being sent.
          </p>
          <Label>What now?</Label>
          <Ul>
            <li>
              This RFP will be always available for future access. You can also
              export your list to CSV.
            </li>
            <li>
              Carriers are not required to answer their emails. If you need any
              other info from them, please contact them directly with the emails
              on the carrier list.
            </li>
          </Ul>
        </div>
      ) : (
        <div>
          <Title>Finish & Award</Title>
          <Hr />
          <P>
            The following list of carriers will receive an email with their
            respective awards:
          </P>
          {Object.values(carriers).map((carrier) => (
            <Label key={carrier.id}>{carrier.name}</Label>
          ))}
          <P>Do you want to proceed?</P>
        </div>
      )}

      {rfp.state !== RFP_STATE.FINALIZED && (
        <ConfirmButton variant="main" onClick={onConfirm}>
          {rfp.meta.isUpdating ? (
            <Spinner type="TailSpin" width={14} height={14} />
          ) : (
            'Submit'
          )}
        </ConfirmButton>
      )}
      <CancelButton variant="secondary" onClick={onClose}>
        {rfp.state !== RFP_STATE.FINALIZED ? 'Cancel' : 'Close'}
      </CancelButton>
    </Modal>
  )
}
